import { ObjectiveClient } from "../services/ohl.virtualCenter.api";

const apiClient = new ObjectiveClient(process.env.REACT_APP_PUBLIC_API);

class ObjectivesProvider {

    getOne = (resource, params) => {
        return apiClient.objectiveGet(params.id).then((data) => {
            return { data };
        });
    };

    getList = (resource, params) => {
        const { page, perPage } = params.pagination;
        const { field, order } = params.sort;

    const query = {
        pageNumber: page,
           pageSize: perPage,
           orderField: field,
           orderAsc: order === "ASC",
           ...params.filter
        };

        return apiClient.list(query).then((data) => ({
            data: data.items || data.elements || data,   
            total: data.totalCount || data.total || 0,
        }));
    };

    update = (resource, params) => {
        return apiClient.objectivePut(params.data).then((data) => ({
           data
        }));
    };

    create = (resource, params) => {
        return apiClient.objectivePost(params.data).then((data) => ({
           data
    }));
};

}

export default new ObjectivesProvider();